/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Editing_PrInputs */

const en_fc_cmp_editing_pr = /** @type {(inputs: Fc_Cmp_Editing_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry-standard editing toolset`)
};

/**
* | output |
* | --- |
* | "Industry-standard editing toolset" |
*
* @param {Fc_Cmp_Editing_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_editing_pr = /** @type {((inputs?: Fc_Cmp_Editing_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Editing_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_editing_pr(inputs)
});
export { fc_cmp_editing_pr as "fc.cmp.editing.pr" }